import MegaMenuNavbar from "../../../MicrospecDynamicUI/Pages/SectionsMapper/Navbar/MegaMenuNavbar";

const MicrospecFlowCommonNavbar = () => {
    return <MegaMenuNavbar spec={{
        showProfile: true,
        showLanguagesMenu: true,
        showThemeModeToggler: true,
        actions: [],
        sticky: true,
    }} />
};

export default MicrospecFlowCommonNavbar;